module.exports = __webpack_public_path__ + "img/modal-mode.decae659.svg";